import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=ad3340b2&"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js&"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VimeoPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports